import useSWR from 'swr';

import getQueryParamsWithoutEmptyVals from 'MODULES/workflows/api/utils/getQueryParamsWithoutEmptyVals';
import { toast } from 'SRC/components/Toast';
import { WORKFLOWS_KEY, getWorkflows } from 'SRC/fetch/api/workflows';

import { WorkflowRevisionChainWithLatestResponse } from '../types/queries/workflows-sources';
import { WorkflowStatus } from '../types/workflowSource';

type QueryParamsType = {
  trigger_action_id?: string;
  trigger_application_id?: string;
  page_size: `${number}`;
  status?: WorkflowStatus;
  page_token?: WorkflowRevisionChainWithLatestResponse['next_page_token'];
};

export const useFetchWorkflows = ({
  queryParams,
  enabled = true,
}: {
  queryParams?: QueryParamsType | null;
  enabled?: boolean;
}) => {
  const searchParams = new URLSearchParams(
    getQueryParamsWithoutEmptyVals(queryParams || {}),
  );
  const searchParamsString = searchParams.toString();
  const key = [WORKFLOWS_KEY, searchParamsString];

  return useSWR(enabled ? key : null, () => getWorkflows(searchParamsString), {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onError: () => {
      toast.negative({
        description: 'Failed to fetch the list of Workflows',
      });
    },
  });
};

/**
 * Usage in a React component :
 * ```
 * const { mutate } = useSWRConfig();
 * mutate(...invalidateWorkflowsListCache());
 * ```
 */
export const invalidateWorkflowsListCache = () => {
  return [
    (key) => {
      return key?.[0] === WORKFLOWS_KEY;
    },
    // Keep the data
    (d) => d,
    {
      // But invalidate the cache
      revalidate: true,
    },
  ] as const;
};
